/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */
/* eslint-disable camelcase */
window.resumePurchase = function resumePurchase() {
  if (confirm('Resuming the held sale will cancel the current sale.  Continue?'))
    window.merchantos.utils.openUrl('/register.php?form_name=resume_purchase');
  return true;
};

// from common.js 12/1/06

window.validate_posint = function validate_posint(input) {
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'string'.
  input.value = parseInt(input.value, 10);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  if (isNaN(input.value)) {
    input.value = '0';
    window.merchantos.focus.set(input);
  }
  // @ts-expect-error ts-migrate(2365) FIXME: Operator '<' cannot be applied to types 'string' a... Remove this comment to see the full error message
  if (input.value < 0) {
    input.value = '0';
    window.merchantos.focus.set(input);
  }
};

window.validate_money = function validate_money(input, name) {
  return window.validateMoney(input, name);
};
